import React from "react";
import Carousel from "../../calculator/carousel/carousel";
import PropTypes from "prop-types";
import "./categoriesList.scss";
import { CAROUSEL_VARIANT } from "../../../constants/calculators";

const CategoriesList = ({
  title,
  categories,
  handleCategoryClick,
  variant = CAROUSEL_VARIANT.DARK
}) => {
  return (
    <div className="categories-list">
      <div className="width-wrapper">
        <div className="categories-title rajdhani-font">
          {title}
        </div>
        <Carousel
          data={categories}
          handleOnClick={handleCategoryClick}
          variant={variant}
        />
      </div>
    </div>
  );
};

CategoriesList.propTypes = {
  title: PropTypes.string,
  categories: PropTypes.object,
  handleCategoryClick: PropTypes.func,
};

export default CategoriesList;
